<template>
  <div class="container pt-4 pb-5">
    <title-area :title="$t('buletinet.title')" />

    <!-- Filters -->
    <div class="row mb-3">
      <!-- WebPage filter -->
      <div class="col-12 col-md-6 mb-2">
        <select v-model="selectedWebPage" class="form-select">
          <option value="">Të gjitha faqet</option>
          <option v-for="(wp, idx) in uniqueWebPages" :key="idx" :value="wp">
            {{ wp }}
          </option>
        </select>
      </div>

      <!-- Month/Year filters -->
      <div class="col-6 col-md-3 mb-2">
        <select v-model="selectedMonth" class="form-select">
          <option value="">{{ $t('buletin_filters.months.title') }}</option>
          <option 
              v-for="(month, idx) in monthNames" 
              :key="idx" 
              :value="idx + 1">
            {{ month }}
          </option>
        </select>
      </div>
      <div class="col-6 col-md-3 mb-2">
        <select v-model="selectedYear" class="form-select">
          <option value="">Viti</option>
          <option v-for="year in uniqueYears" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
      </div>
    </div>

    <!-- Buletins -->
    <BuletinsTemplate :paginatedBuletins="paginatedBuletins" :currentPage="currentPage" :totalPages="totalPages"
      :visiblePages="visiblePages" @download="download" @goToPage="goToPage" />
  </div>
</template>

<script>
import TitleArea from '../share/TitleArea.vue';
import BuletinsTemplate from '../share/BuletinsTemplate.vue';
import { usePostsStore } from '@/store/PostStore/postStore';

export default {
  components: { TitleArea, BuletinsTemplate },
  data() {
    return {
      postStore: usePostsStore(),
      currentPage: 1,
      itemsPerPage: 4,
      selectedWebPage: "",
      selectedMonth: "",
      selectedYear: "",
      language: 'AL',
      count: 0,
      categoryId: 1149,
      subdomain: ''
    };
  },
  computed: {
    uniqueWebPages() {
      const allPages = this.postStore.buletins.map(p => p.webPage);
      return [...new Set(allPages.filter(p => p))];
    },

    uniqueYears() {
      const years = this.postStore.buletins.map(post => {
        if (!post.createdDate) return null;
        const parts = post.createdDate.split(".");
        return parts.length === 3 ? parts[2] : null;
      });
      return [...new Set(years.filter(y => y))].sort((a, b) => b - a);
    },

    formatedBuletins() {
      if (!this.postStore.buletins) return [];   // shto këtë guard
      return this.postStore.buletins.map((post) => ({
        id: post.id,
        title: post.priceDetailsTitle,
        date: post.createdDate,
        fileUrl: post.pDetailsFileUrl,
        webPage: post.webPage
      }));
    },

    totalPages() {
      return Math.ceil(this.filteredBuletins.length / this.itemsPerPage) || 1;
    },
    paginatedBuletins() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredBuletins.slice(start, end);  // ❌ këtu bie nese filteredBuletins është undefined
    },
    filteredBuletins() {
      let list = this.formatedBuletins || [];

      if (this.selectedWebPage) {
        list = list.filter(b => b.webPage === this.selectedWebPage);
      }

      if (this.selectedMonth || this.selectedYear) {
      list = list.filter(b => {
        const parts = b.date.split(".");
        const m = parseInt(parts[1]);
        const y = parseInt(parts[2]);
        const condMonth = this.selectedMonth ? m === parseInt(this.selectedMonth) : true;
        const condYear = this.selectedYear ? y === parseInt(this.selectedYear) : true;
        return condMonth && condYear;
      });
    }
      return list;
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;
      if (total <= 5) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        if (current <= 3) {
          pages.push(1, 2, 3, 4, '...', total);
        } else if (current >= total - 2) {
          pages.push(1, '...', total - 3, total - 2, total - 1, total);
        } else {
          pages.push(1, '...', current - 1, current, current + 1, '...', total);
        }
      }
      return pages;
    },
    monthNames() {
    // përdor i18n për tri gjuhë
    return [
      this.$t('buletin_filters.months.january'),
      this.$t('buletin_filters.months.february'),
      this.$t('buletin_filters.months.march'),
      this.$t('buletin_filters.months.april'),
      this.$t('buletin_filters.months.may'),
      this.$t('buletin_filters.months.june'),
      this.$t('buletin_filters.months.july'),
      this.$t('buletin_filters.months.august'),
      this.$t('buletin_filters.months.september'),
      this.$t('buletin_filters.months.october'),
      this.$t('buletin_filters.months.november'),
      this.$t('buletin_filters.months.december')
    ];
  }
  },
  created() {
    this.fetchBuletins();
    this.getSubdomain();
  },
  methods: {
    getSubdomain() {
      const host = window.location.hostname;
      this.subdomain = host.includes('.') ? host.split('.')[0] : '';
    },
    async fetchBuletins() {
      try {
        const postsData = {
          webPage: this.subdomain || 'kpk',  // vendos subdomain ose ndonjë default
          language: this.language,
          count: this.count,
          categoryId: this.categoryId,
        };
        await this.postStore.getBuletins(postsData);
      } catch (error) {
        console.error('❌ Error fetching buletins:', error);
      }
    },

    download(url) {
      window.open(url, "_blank");
    },
    goToPage(page) {
      if (page === '...') return;
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    }
  },
  watch: {
    // Reset page kur ndryshon filtri
    selectedWebPage() { this.currentPage = 1; },
    selectedMonth() { this.currentPage = 1; },
    selectedYear() { this.currentPage = 1; }
  }
};
</script>

